// Immunocal SG — Product Feature carousel ("More Products to Love")
// Crossfades product slides; optional autoplay, arrows, dots, touch swipe.
// With a single slide it stays static (no controls).

class CustomProductFeature extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-cpf-slide]'));
    this.dotsWrap = this.querySelector('[data-cpf-dots]');
    this.count = this.slides.length;
    if (this.count === 0) return;

    this.index = 0;
    this.autoplay = this.dataset.autoplay === 'true';
    this.interval = parseInt(this.dataset.interval, 10) || 6000;
    this.loop = this.dataset.loop !== 'false';
    this.timer = null;

    this.buildDots();
    this.bindArrows();
    this.bindSwipe();
    this.bindPausing();

    this.setActive(0);
    this.maybeStart();
  }

  disconnectedCallback() { this.stop(); }

  setActive(i) {
    if (this.loop) this.index = (i + this.count) % this.count;
    else this.index = Math.max(0, Math.min(i, this.count - 1));
    this.slides.forEach((s, idx) => s.classList.toggle('is-active', idx === this.index));
    if (this.dots) this.dots.forEach((d, idx) => d.setAttribute('aria-current', idx === this.index ? 'true' : 'false'));
  }

  next() { this.setActive(this.index + 1); }
  prev() { this.setActive(this.index - 1); }
  goTo(i) { this.setActive(i); this.restart(); }

  maybeStart() { if (this.autoplay && this.count > 1) this.start(); }
  start() { this.stop(); this.timer = setInterval(() => this.next(), this.interval); }
  stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
  restart() { if (this.autoplay && this.count > 1) this.start(); }

  buildDots() {
    if (!this.dotsWrap || this.count < 2) return;
    this.dots = [];
    this.slides.forEach((_, idx) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', `Go to slide ${idx + 1}`);
      dot.addEventListener('click', () => this.goTo(idx));
      this.dotsWrap.appendChild(dot);
      this.dots.push(dot);
    });
  }

  bindArrows() {
    this.querySelector('[data-cpf-prev]')?.addEventListener('click', () => { this.prev(); this.restart(); });
    this.querySelector('[data-cpf-next]')?.addEventListener('click', () => { this.next(); this.restart(); });
  }

  bindSwipe() {
    let startX = 0, active = false;
    const vp = this.querySelector('[data-cpf-viewport]') || this;
    vp.addEventListener('pointerdown', (e) => { if (e.pointerType === 'mouse') return; startX = e.clientX; active = true; });
    vp.addEventListener('pointerup', (e) => {
      if (!active) return; active = false;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 45) { dx < 0 ? this.next() : this.prev(); this.restart(); }
    });
    vp.addEventListener('pointercancel', () => { active = false; });
  }

  bindPausing() {
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.stop(); else this.maybeStart();
    });
  }
}

if (!customElements.get('custom-product-feature')) {
  customElements.define('custom-product-feature', CustomProductFeature);
}
